import { createSelector } from '@reduxjs/toolkit';
import { findRouteByTemplate } from 'features/breadcrumbs/model/findRouteByTemplate';

export const selectBreadcrumbs = state => state.navigation.breadcrumbs;

const resolveLabel = (entry, state) => {
  const route = findRouteByTemplate(entry.pathTemplate);
  const cfg = route?.additional?.breadcrumb;
  if (!cfg) return '';
  if (typeof cfg.label === 'function') {
    return cfg.label({ params: entry.params, state }) || '';
  }
  return cfg.label || '';
};

export const selectBreadcrumbsResolved = createSelector(
  [selectBreadcrumbs, state => state],
  (raw, state) => raw.map(entry => ({ ...entry, label: resolveLabel(entry, state) }))
);
